import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=876ee440&"
import script from "./MedicalRecord.vue?vue&type=script&lang=js&"
export * from "./MedicalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports